import Grid from "@mui/material/Grid";
import type { DREGerencialView } from "../types/dre-gerencial.types";
import { formatarMoedaBRL } from "../helpers/financeiro-formatters";
import FinanceiroResumoCard from "./FinanceiroResumoCard";

type Props = {
  view: DREGerencialView | null;
  loading?: boolean;
};

export default function DREGerencialResumoCards({ view, loading }: Props) {
  const v = view;

  const tipoLucro = (n: number | undefined) =>
    n == null ? ("neutro" as const) : n >= 0 ? ("positivo" as const) : ("negativo" as const);

  /** Negativo em vermelho; zero ou positivo em preto (text.primary). */
  const tipoNegativoOuPreto = (n: number | undefined) =>
    n == null ? ("neutro" as const) : n < 0 ? ("negativo" as const) : ("neutro" as const);

  const jurosLoja = v?.receitaDetalhada.loja.jurosParcelamento ?? 0;
  const jurosInsc = v?.receitaDetalhada.inscricoes.jurosParcelamento ?? 0;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={3}>
        <FinanceiroResumoCard
          titulo="Receita líquida"
          valor={v?.receitaLiquida}
          formato="moeda"
          loading={loading}
          tipo={tipoNegativoOuPreto(v?.receitaLiquida)}
          descricao="Após taxas gateway e estornos"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <FinanceiroResumoCard
          titulo="CMV"
          valor={v?.cmvTotal}
          formato="moeda"
          loading={loading}
          descricao={
            v && v.participacaoCmv > 0
              ? `${(v.participacaoCmv * 100).toFixed(1).replace(".", ",")}% da receita líquida`
              : "Custo dos produtos vendidos (pedidos)"
          }
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <FinanceiroResumoCard
          titulo="Lucro bruto"
          valor={v?.lucroBruto}
          formato="moeda"
          loading={loading}
          tipo={tipoNegativoOuPreto(v?.lucroBruto)}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <FinanceiroResumoCard
          titulo="Margem bruta"
          valor={v?.margemBruta}
          formato="percentual"
          loading={loading}
          tipo={tipoLucro(v?.margemBruta)}
          descricao="Lucro bruto ÷ receita líquida"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <FinanceiroResumoCard
          titulo="Despesas operacionais"
          valor={v?.despesasTotal}
          formato="moeda"
          loading={loading}
          tipo="alerta"
          descricao="Títulos pagos no período + ajustes"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <FinanceiroResumoCard
          titulo="Lucro operacional"
          valor={v?.lucroOperacional}
          formato="moeda"
          loading={loading}
          tipo={tipoLucro(v?.lucroOperacional)}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <FinanceiroResumoCard
          titulo="Margem operacional"
          valor={v?.margemOperacional}
          formato="percentual"
          loading={loading}
          tipo={tipoLucro(v?.margemOperacional)}
          descricao="Lucro operacional ÷ receita líquida"
        />
      </Grid>
      {jurosLoja >= 0.01 ? (
        <Grid item xs={12} sm={6} md={3}>
          <FinanceiroResumoCard
            titulo="Juros parcelamento — loja"
            valor={jurosLoja}
            formato="moeda"
            loading={loading}
            descricao={`Comercial: ${v ? formatarMoedaBRL(v.receitaDetalhada.loja.receitaComercial) : "—"}`}
          />
        </Grid>
      ) : null}
      {jurosInsc >= 0.01 ? (
        <Grid item xs={12} sm={6} md={3}>
          <FinanceiroResumoCard
            titulo="Juros parcelamento — inscrições"
            valor={jurosInsc}
            formato="moeda"
            loading={loading}
            descricao={`Comercial: ${v ? formatarMoedaBRL(v.receitaDetalhada.inscricoes.receitaComercial) : "—"}`}
          />
        </Grid>
      ) : null}
    </Grid>
  );
}
